export const isDataLoading = (state) => state.locations.isLoading;
